import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SheetPlastificado } from '../../../../types/models/manufacturing/mallaOlimpicaPlastificado.model.type';

interface SheetPlastificadoState {
  isFetching: boolean;
  data: SheetPlastificado[];
  total: number;
  error: string | undefined;
  selectedItem?: SheetPlastificado;
  filters: {
    materialCode: string;
    pageNumber: number;
    pageSize: number;
  };
}

const initialState: SheetPlastificadoState = {
  isFetching: false,
  data: [],
  total: 0,
  error: undefined,
  selectedItem: undefined,
  filters: {
    materialCode: '',
    pageNumber: 1,
    pageSize: 50,
  },
};

const sheetPlastificadoSlice = createSlice({
  name: 'sheetPlastificado',
  initialState,
  reducers: {
    rxStartFetching: (state) => {
      state.isFetching = true;
    },
    rxSuccessFetching: (
      state,
      { payload }: PayloadAction<{ list: SheetPlastificado[]; total: number }>,
    ) => {
      state.isFetching = false;
      state.data = payload.list;
      state.total = payload.total;
    },
    rxErrorFetching: (state) => {
      state.isFetching = false;
      state.data = [];
    },
    rxSetFilters: (state, { payload }: PayloadAction<any>) => {
      state.filters = { ...state.filters, ...payload };
    },
    rxSetSelectedItem: (
      state,
      { payload }: PayloadAction<SheetPlastificado | undefined>,
    ) => {
      state.selectedItem = payload;
    },
    rxResetSelectedItem: (state) => {
      state.selectedItem = undefined;
    },
    rxSetPageNumber: (state, { payload }: PayloadAction<number>) => {
      state.filters.pageNumber = payload;
    },
    rxSetPageSize: (state, { payload }: PayloadAction<number>) => {
      state.filters.pageSize = payload;
      state.filters.pageNumber = 1; // Reiniciar página al cambiar el tamaño
    },
  },
});

export const {
  rxStartFetching,
  rxSuccessFetching,
  rxErrorFetching,
  rxSetFilters,
  rxSetSelectedItem,
  rxResetSelectedItem,
  rxSetPageNumber,
  rxSetPageSize,
} = sheetPlastificadoSlice.actions;

export default sheetPlastificadoSlice.reducer;
